module.exports = __webpack_public_path__ + "static/img/voice_mail_3.479d5fb8.svg";